import { render, staticRenderFns } from "./CancelExplain.vue?vue&type=template&id=1e53476a&scoped=true&"
var script = {}
import style0 from "./CancelExplain.vue?vue&type=style&index=0&id=1e53476a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e53476a",
  null
  
)

export default component.exports